import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import Contact from '@app/features/addressBook/types/Contact';

export type ContactForBulkCreate = Omit<Contact, 'createdAt' | 'updatedAt' | 'id'>;
export type CreateBulkContactsParams = Array<ContactForBulkCreate>;
export type CreateBulkContactsResponse = { contactIds: string[] };

export function createBulkContacts(contacts: CreateBulkContactsParams) {
  return requestApi<CreateBulkContactsResponse>({
    url: withDocument('/address-book/bulk/contacts'),
    method: 'POST',
    credentials: true,
    data: {
      contactData: contacts,
    },
  }).then((response) => response.data);
}
